import { useDispatch, useSelector } from 'react-redux';
import { handleBrandChange } from 'actions/Auth';

const useRefreshIfActiveBrandRemoved = brands => {
  const dispatch = useDispatch();
  const selectedBrand = useSelector(state => state.Auth.selectedBrand);

  return removedBrand => {
    if (!removedBrand || Number(removedBrand.id) !== Number(selectedBrand)) {
      return;
    }

    const fallbackBrand = brands.find(
      ({ id }) => Number(id) !== Number(removedBrand.id)
    );

    if (fallbackBrand) {
      dispatch(
        handleBrandChange(null, {
          brand: { id: fallbackBrand.id },
          refresh: true,
        })
      );

      return;
    }

    window.location.reload();
  };
};

export default useRefreshIfActiveBrandRemoved;
